module.exports = __webpack_public_path__ + "static/media/mob-affi12.711bc788.webp";